// Schema capable de valider une valeur inconnue (schemas Zod de @killer-party/contracts).
export interface Parser<T> {
  parse(value: unknown): T;
}

// Valide la propriete `key` d'une reponse enveloppee ({ mission }, { target }…).
export function field<T>(key: string, schema: Parser<T>): (raw: unknown) => T {
  return (raw) => schema.parse((raw as Record<string, unknown> | null)?.[key]);
}
